import {useCallback} from 'react';
import createRetryQuizSessionDoc from '../../api/quizSession/createRetryQuizSessionDoc';
import getQuizSessionDoc from '../../api/quizSession/getQuizSessionDoc';
import {firebaseAuth} from '../../config/firebase';
import getUserDoc from '../../api/user/getUserDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useRetryQuiz() {
  const retryFn = useCallback(async (moduleId: string, sessionId: string) => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const user = await getUserDoc(uid);

    const hasModuleAccess = user?.selectedModules?.some((m) => m.moduleId === moduleId);
    if (!hasModuleAccess) {
      throw new Error('You do not have access to this module');
    }

    const session = await getQuizSessionDoc(uid, sessionId);
    if (!session) throw new Error('Session not found');
    if (session.moduleId !== moduleId) {
      throw new Error('Session does not match module');
    }

    return createRetryQuizSessionDoc(uid, session);
  }, []);

  const {fn, loading, error} = useFunctionWrap(retryFn);

  return {
    retryQuiz: fn,
    loading,
    error,
  };
}
